import { PropTypes } from 'prop-types';
import React, { useState } from 'react';

import Link from '../../Link';

const CardTextBasedMediumHighlight = ({ author, title, url }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <Link className="relative block h-full" to={url}>
        <div className="absolute inset-0 z-0 bg-lilac" />
        <div
          className="absolute inset-0 z-10 transition-all duration-500 ease-out bg-berry"
          style={{ clipPath: `circle(${hovered ? `100%` : `30%`})` }}
        />
        <div className="relative z-20 flex flex-col items-center justify-center h-full px-8 py-4 text-center text-hover lg:py-5 lg:px-15 text-squid-ink sm:py-10 sm:px-24">
          <p className="stink-footnote">Comment</p>
          <h3 className="stink-h3 lg:my-24 sm:my-18 my-28">{title}</h3>
          <p className="stink-footnote">{author}</p>
        </div>
      </Link>
    </div>
  );
};

CardTextBasedMediumHighlight.propTypes = {
  author: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default CardTextBasedMediumHighlight;
